module.exports = __webpack_public_path__ + "static/img/u9.87745ed9.png";